import HeaderDefault from '@/components/_core/ui/header';
import { mapGetters, mapState } from 'vuex';

export default {
  components: {
    HeaderDefault
  },
  head() {
    return {
      title         : this.headTitle,
      titleTemplate : `%s :: ${process.env.APPLICATION_TITLE}`,
      meta          : [
        { name: 'theme-color', content: this.themes.light.primary },
        { name: 'msapplication-navbutton-color', content: this.themes.light.primary },
        { name: 'apple-mobile-web-app-status-bar-style', content: this.themes.light.primary }
      ],
      link: [
        { rel: 'icon', type: 'image/x-icon', href: this.themes.favicon, id: '#favicon' }
      ]

    };
  },
  data() {
    return {
      type                    : 'authenticated',
      displayProfileSelection : 'page',
      configBorder            : '',
      fluid                   : false
    };
  },
  created() {
    console.warn('This layout is deprecated. Please upgrade to _core/authenticated');
  },
  computed: {
    ...mapGetters({
      dark                : '_core/application/isDark',
      userIsAuthenticated : '_core/auth/isAuthenticated'
    }),
    ...mapState({
      themes        : state => state._core.application.themes,
      tenantsRights : state => state._core.auth.tenantsRights
    }),
    headTitle() {
      return this.$t('_core.common.loading');
    }
  }
};
